import React, { Component } from 'react';
import { connect} from "remx";

import authStore from "../../stores/auth";
import dataStore from "../../stores/data";
import broker from "../../utils/broker";


class Sidebar extends Component {
    constructor(props) {
        super(props);
    
        this.state = {
            data_klasifikasi : [],
            data_kategori_per: [],
            data_sub: [],
            nav_data : {},
            klasifikasi_sub: {},
            child_data : {},
            sub_child_data: {},
            kategori_id : '',
            klasifikasi_id : '',
        }
        this.toggleNav = this.toggleNav.bind(this);
        this.setKlasifikasi = this.setKlasifikasi.bind(this);
    }

    getDataKlasifikasiSub(id){
        broker.fetch.get(`/list/klasifikasi/${id}/sub`)
        .then(res => {
            const { data } = res;
            if (data.status === true) {
                this.setState({data_sub : data.data})
            } else {

            }
        }).catch(err => {
            
        });
    }

    getDataKategori(){
        let nav = {}
        let klasifikasi_sub = {}
        broker.fetch.get(`/data/user/${this.props.user.id}/kategori_klasifikasi`)
        .then(res => {
            const { data } = res;
            if (data.status === true) {
                this.setState({data_kategori : data.data}, function(){
                      var data_kategori = this.state.data_kategori;
                        for (var i=0; i<data_kategori.length; i++){
                            nav[data_kategori[i].id] = '';
                            for (var j=0; j<data_kategori[i].kategori.klasifikasi.length; j++){
                                klasifikasi_sub[data_kategori[i].kategori.klasifikasi[j].id] = 'collapse';
                            }
                        }
                        this.setState({nav_data : nav, klasifikasi_sub : klasifikasi_sub})
                })
            } else {

            }
        }).catch(err => {
            
        });
    }

    componentDidMount(){
        dataStore.setters.setDataPer({})
        this.getDataKategori();
    }

    toggleNav(e, id, kategori_id){
        e.preventDefault();

        dataStore.setters.setDataKlasifikasi({kategori_id : kategori_id, klasifikasi_id : '', sub_klasifikasi_id : ''});
        dataStore.setters.setDataKategoriPer({id_kategori : kategori_id});  

        var nav_data = this.state.nav_data;
    
        for (var key in nav_data){
            nav_data[key] = '';
            if (key === id){
                nav_data[key] = (nav_data[key] === '') ? ' show' : '';
            }
        }
    
        var child_data = this.state.child_data;
        for (var index in child_data){
            child_data[index] = '';
        }
    
        this.setState({nav_data : nav_data, child_data: child_data});
    }

    setKlasifikasi(e, kategori_id, klasifikasi_id){
        e.preventDefault();

        this.setState({child_data : {[klasifikasi_id] : 'active'}, klasifikasi_id : klasifikasi_id});
        dataStore.setters.setDataKlasifikasi({kategori_id : kategori_id, klasifikasi_id : klasifikasi_id, sub_klasifikasi_id : ''});
        this.getDataKlasifikasiSub(klasifikasi_id)

        var klasifikasi_sub = this.state.klasifikasi_sub;
        for (var key in klasifikasi_sub){
            klasifikasi_sub[key] = 'collapse';
            if (key === klasifikasi_id){
                klasifikasi_sub[key] = (klasifikasi_sub[key] === 'nav') ? 'collapse' : 'nav';
            }
        }

        this.setState({klasifikasi_sub : klasifikasi_sub});
    }

    setSub(e, kategori_id, klasifikasi_id, sub_id){
        e.preventDefault();

        this.setState({sub_child_data : {[sub_id] : 'active'}});
        dataStore.setters.setDataKlasifikasi({kategori_id : kategori_id, klasifikasi_id : klasifikasi_id, sub_klasifikasi_id : sub_id});
    }

    render(){
        return(
            <div id="sidebarMenu" className="sidebar sidebar-fixed sidebar-components">
                <div className="filemgr-sidebar-body" style={{padding: '25px', top: '1px'}}>
                    <ul className="sidebar-nav">
                        <li className="nav-label mg-b-15">Kategori Pekerjaan</li>
                        {(this.state.data_kategori) &&
                            this.state.data_kategori.map((data, i) => {
                                return <li className={"nav-item" + this.state.nav_data[data.id]} key={i}>
                                            <a href="#!" onClick={(e) => this.toggleNav(e, data.id, data.kategori_id)} 
                                                className={"nav-link with-sub cursor-pointer " + ((this.state.nav_data[data.id]) ? 'active' : '')}> 
                                                {data.kategori.nama_keterangan}
                                            </a>
                                            <nav className="nav">
                                            {(data.kategori.klasifikasi) &&
                                                data.kategori.klasifikasi.map((klasifikasi, j) =>{
                                                    return <li className={"nav-item"} key={j}>
                                                    <a href="#!" onClick={(e) => this.setKlasifikasi(e, data.kategori_id, klasifikasi.id)} 
                                                        className={"cursor-pointer " + ((this.state.child_data[klasifikasi.id]) ? this.state.child_data[klasifikasi.id] : '')} key={j}>
                                                            {klasifikasi.nama}
                                                    </a>
                                                    <nav className={this.state.klasifikasi_sub[klasifikasi.id] }>
                                                        {(klasifikasi.sub) &&
                                                            klasifikasi.sub.map((sub, k) =>{
                                                                return <a href="#!" onClick={(e) => this.setSub(e, data.kategori_id, klasifikasi.id, sub.id)} className={"cursor-pointer " + ((this.state.sub_child_data[sub.id]) ? this.state.sub_child_data[sub.id] : '')} key={k}>{sub.nama}</a>
                                                            })
                                                        }
                                                    </nav>
                                                    </li>
                                                })
                                            }
                                            </nav>
                                        </li>})
                        }
                    </ul>
                </div>
            </div>
        );
    }

}

function mapStateToProps(props) {
    return {
        user: authStore.getters.getUser(),
        data_kategori : dataStore.getters.getDataKategori(),
        data_kategori_per : dataStore.getters.getDataKategoriPer(),
        data_klasifikasi : dataStore.getters.getDataKlasifikasi()
    }
}

export default connect(mapStateToProps)(Sidebar);